/** @format */

import React from 'react';

import {campaignLink} from 'helpers/reportHelpers';

import {CampaignLink, CampaignName} from './styles';

interface YandexDirectLinkProps {
  accountName?: string;
  campaignId: string;
  campaignName: string;
  onCampaignNameClick?: (campaignId: string) => void;
}

const YandexDirectLink = ({
  accountName,
  campaignId,
  campaignName,
  onCampaignNameClick,
}: YandexDirectLinkProps) => {
  if (!accountName) {
    return <CampaignName>{campaignName ?? ''}</CampaignName>;
  }

  const url = campaignLink('YANDEX', accountName, campaignId);

  if (!url) {
    return <CampaignName>{campaignName ?? ''}</CampaignName>;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onCampaignNameClick?.(campaignId);
  };

  return (
    <CampaignLink href={url} target='_blank' rel='noopener noreferrer' onClick={handleClick}>
      {campaignName}
    </CampaignLink>
  );
};

export default YandexDirectLink;
